export const MAX_TICKETS_ON_WHITELIST = 3;